export const menuItems = [
  { text: "Users", path: "/dashboard" },
  { text: "Users", path: "/view-user" },
  { text: "Users", path: "/create-user" },
  { text: "Product Management", path: "/products" },
  { text: "Product Management", path: "/view-product" },
  { text: "Notification Management", path: "/notification" },
  { text: "Notification Management", path: "/view-notification-file" },
  { text: "CX Center Management", path: "/support" },
  { text: "Help Center Management", path: "/help-center" },
  { text: "Terms and Condition", path: "/terms-and-conditions" },
  { text: "Manage User Roles", path: "/manage-user-role" },
  { text: "Manage User Roles", path: "/create-user-role" },
  { text: "Manage User Roles", path: "/edit-user-role" },
  { text: "Audit Trail", path: "/audit-trail" },
  { text: "App Updates", path: "/app-updates" },
  { text: "Idle Time", path: "/idle-time" },
];
